import type { ReferentialCode } from "../types"

export const datarefToReferentialCode = <
  T extends string | number = string | number,
>(
  dataref: { id: T; name: string }[],
): ReferentialCode<T>[] =>
  dataref.map((r) => ({
    code: r.id,
    label: r.name,
  }))
